export default {
  SET_NOTIFS(state, notifs) {
    state.notifications = notifs
  }
};
